import { ApplicationConfig } from '@angular/core';
import { provideCore } from '@core/core';

export const appConfig: ApplicationConfig = {
  providers: provideCore()
};
